import { render, staticRenderFns } from "./AssignedUsers.vue?vue&type=template&id=4b6a1900"
import script from "./AssignedUsers.vue?vue&type=script&lang=ts"
export * from "./AssignedUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports